module.exports = __webpack_public_path__ + "static/media/vivo_265.637aa0c2.png";